import {
  SlRadio
} from "./chunk.N5H7JIU3.js";

// src/components/radio/radio.ts
var radio_default = SlRadio;
SlRadio.define("sl-radio");

export {
  radio_default
};
